export const snapshotManagementMessages = {
  en: {
    pageTitle: 'Snapshot Management',
    tree: {},
    settingsNoPasswordDialog: {
      title: 'The snapshot was loaded from offline sources.',
      subTitle:
        'The following information was removed, please inspect the Authentication tab.',
      btnConfirm: 'Continue',
      credential: '{credentials} credential was removed.',
      credentials: '{credentials} credentials were removed.',
      enablePassword: '{privileges} enable password was removed.',
      enablePasswords: '{privileges} enable passwords were removed.',
    },
    loading: 'Loading',
    loadedSnapshotsTitle: 'Loaded Snapshots',
    noSitesFound: 'No sites found',
    notAvailable: 'N/A',
    snapshotLocked: "Locked, can't be modified",
    unloadedSnapshotsTitle: 'Unloaded Snapshots',
    snapshotNotFound: 'Snapshot not found',
    unknownSnapshotError: 'Unknown snapshot error',
    name: {
      validation: {
        length: 'Length must not be greater than {MAX_LENGTH} characters',
      },
    },
    sitesFilter: 'Sites Filter',
    buttonToolbar: {
      cloneSnapshot: 'Clone snapshot',
      deleteSnapshot: 'Delete snapshot',
      deleteSnapshots: 'Delete snapshots',
      downloadSnapshot: 'Download snapshot',
      loadSnapshot: 'Load snapshot',
      loadSnapshots: 'Load snapshots',
      lockSnapshot: 'Lock snapshot',
      runTopologyCalculation: 'Run Topology Calculation',
      unloadSnapshot: 'Unload snapshot',
      unloadSnapshots: 'Unload snapshots',
      unlockSnapshot: 'Unlock snapshot',
      connectivityReport: 'Connectivity Report',
      deleteDevice: 'Delete device',
    },
    deleteSnapshotDialogue: {
      header: 'Snapshot from {tsStart} will be deleted',
      headerName: 'Snapshot {name} will be deleted',
      subHeader: 'Do you really want to delete snapshot?',
      headerMulti: '{totalSnapshots} snapshots will be deleted',
      subHeaderMulti: 'Do you really want to delete snapshots?',
      btnCancel: 'Cancel',
      btnConfirm: 'Delete',
    },
    upload: {
      btnUpload: 'Load snapshot from file',
      wrongExtension: 'File extension must be .tar, .tgz or .tar.gz',
    },
    cancelDiscoveryDialogue: {
      header: 'Cancel the Discovery Process',
      subHeader:
        'Terminating this process will stop further network device discovery in this snapshot and the snapshot will be kept in a current state. Topology Calculation and Assurance Engine checks will not execute.',
      btnSecondaryConfirm: 'Dismiss',
      btnConfirm: 'Cancel Discovery',
    },
    cancelSnapshotLoadDialogue: {
      header: 'Cancel the Snapshot Load Process',
      subHeader:
        'Terminating this process will stop the current snapshot loading process and will unload the snapshot.',
      btnSecondaryConfirm: 'Dismiss',
      btnConfirm: 'Cancel Snapshot Load',
    },
    cancelTopologyCalculationDialogue: {
      header: 'Cancel the Topology Calculation Process',
      subHeader:
        'Terminating this process will stop the Topology Calculation process and other related Assurance Engine operations.',
      btnSecondaryConfirm: 'Dismiss',
      btnConfirm: 'Cancel Topology Calculation',
    },
    detail: {
      devices: 'Devices (total/licensed):',
      licenseUsage: 'License usage:',
      loadedSize: 'Loaded size on disk:',
      note: 'Notes:',
      noteEmpty: 'Empty',
      selectedSnapshots: 'Selected {totalSnapshots} snapshots',
      sites: 'Sites:',
      status: 'Status:',
      time: 'Start time:',
      unloadedSize: 'Unloaded size on disk:',
      version: 'Snapshot data version:',
      creator: 'Creator:',
      createdOn: 'created on',
      createdOnVersion: 'Created on version:',
      duration: 'Duration:',
      unknown: 'Unknown',
    },
    snapshotLoadingBar: {
      title: 'Loading snapshot',
      devicesOfLoaded: 'Devices: {loaded} of {total} loaded',
      pctLoaded: '% loaded',
    },
    request: {
      topologyCalculationStopped: 'Topology calculation was stopped',
      cloned: 'Snapshot cloned',
      unload: 'Snapshot unloaded',
      delete: 'Snapshot deleted',
      snapshotConflict: "Can't upload, snapshot already exists",
      noAuthentication: 'Authentication must be configured before start',
      discoveryScheduled: 'Discovery has been scheduled',
      discoveryLicenseExceeded: 'License device limit exceeded',
      alreadyStarting: 'Please wait, the discovery process is already starting',
      nothingToDo: 'No timed out IP addresses exist',
      snapshotLoadStarted: 'Snapshot load started',
      logNotFound: "The service log file doesn't exist for this snapshot",
      setCredentialsFirst:
        'Please set Device credentials or Vendor API(s) in discovery settings first',
      siteRecalculationStarted: 'Sites recalculations started',
      siteRecalculationFinished: 'Sites recalculations finished',
      settingsSaved: 'Settings saved',
      discoveryFinished: 'Discovery finished',
      snapshotLoadFinished: 'Snapshot loaded',
    },
    stopButtonTitle: 'Cancel',
    stoppingButtonTitle: 'Cancelling...',
    startButton: {
      settings: 'Settings',
      newSnapshot: 'Create snapshot',
      playButtonTooltip: 'Start discovery',
      addDevices: 'Add devices',
      updateData: 'Refresh device data',
      btnClose: 'Close',
      btnStartDiscovery: 'Start discovery',
    },
    discovery: {
      finish: {
        mainMsg:
          'Please be patient it can take a while. See the Services logs for details.',
        bottomText: 'Network topology building has been started.',
      },
      discoQueueProcessed: 'Processed',
      discoQueueRemaining: 'Remaining',
      infoDiscovered: 'Discovered',
      addresses: 'Addresses:',
      networks: 'Networks:',
      timeElapsed: 'Time elapsed',
      licensed: 'Licensed:',
      bandwidth: {
        bandwidthLimit: 'Bandwidth limit',
        bandwidthUtilization: 'Bandwidth utilization RX/TX: {number} Kb/s',
        limit: '{number} Mb/s',
        disabled: 'Disabled',
      },
      rows: 'rows',
      total: 'Total:',
      discoveryFinished: 'Discovery finished',
      inProgress: 'Discovery in progress',
      loadingSnapshot: 'Loading snapshot',
      devicesInventory: {
        tableTitle: 'Inventory Devices',
        noDevicesDiscovered: 'No devices discovered yet',
        noDevicesLoaded: 'No devices loaded yet',
        noDevicesFound: 'No devices found',
        noDevices: 'No devices',
        runDiscovery: 'Click on the play button to start discovery',
        tabTitle: 'Inventory',
        columns: {
          hostname: 'Hostname',
          sn: 'Serial Number',
          vendor: 'Vendor',
          family: 'Family',
          version: 'Version',
          siteName: 'Site',
          platform: 'Platform',
          model: 'Model',
        },
        deleteDeviceDialogue: {
          header: 'Selected devices will be deleted',
          subHeader: 'Do you really want to delete selected devices?',
          btnSecondaryConfirm: 'Cancel',
          btnConfirm: 'Delete',
        },
        deleteLoader: {
          text: 'Please be patient, it may take a while.',
          bottomText: 'Please wait, deleting devices.',
        },
        refreshLoader: {
          text: 'Please be patient, it may take a while.',
          bottomText: 'Please wait, deleting devices.',
        },
        addLoader: {
          bottomText:
            'Discovery process is scheduled, please wait for starting',
        },
      },
      devicesInProgress: {
        tableTitle: 'The IP addresses in processing',
        nothingInQueue: 'Nothing in the queue',
        tabTitle: 'Currently in progress',
        waitingForStats: 'Waiting to get the current queue',
        columns: {
          ip: 'IP / Object Id',
          time: 'Last communication',
          task: 'Task',
        },
      },
      servicesLogs: {
        tabTitle: 'Services logs',
      },
      terminal: {
        countOfRows: 'Count of rows',
        collapse: 'Collapse',
        downloadLog: 'Download log',
        tasker: 'Tasker',
        worker: 'CLI Worker',
        netWorker: 'Trace Worker',
      },
      errorsSummary: {
        tabTitle: 'Summary of Issues',
        noError: 'No issues',
      },
    },
    status: {
      run: 'run',
      done: 'done',
      error: 'error',
      finishing: 'finishing',
      ready: 'ready',
      'server-restarted': 'server restarted',
      canceled: 'canceled',
    },
    snapshotCreation: {
      deleteDevicesButton:
        'Delete ({count, plural, one {# row} other {# rows}} selected)',
      refreshDevicesButton:
        'Refresh ({count, plural, one {# row} other {# rows}} selected)',
      startDiscoveryButton: 'Start Discovery',
    },
  },
};
